export default class Delay {
  delay: number = 1000;

  timer: NodeJS.Timeout | null;

  constructor(delay?: number, callback?: () => void) {
    this.delay = delay === undefined ? this.delay : delay;
    this.timer = setTimeout(() => {
      this.timer = null;
      if (callback) {
        callback();
      }
    }, delay);
  }

  public setDelay(delay: number): void {
    this.delay = delay;
  }

  public start(callback?: () => void): Delay {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.timer = null;
      if (callback) {
        callback();
      }
    }, this.delay);

    return this;
  }

  public stop(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
